import AdminPanelDashboard from '@/views/admin/AdminDashboard.vue'
import UserManagement from '@/views/admin/UserManagement.vue'
import CourseManagement from '@/views/admin/CourseManagement.vue'
import Analytics from '@/views/admin/Analytics.vue'
import AdminCreateCourse from '@/views/admin/AdminCreateCourse.vue'
import { ADMIN_ONLY_ROLES } from '../routeRoles'

export const adminRoutes = [
	{
		path: '/admin',
		redirect: '/admin/dashboard',
	},
	{
		path: '/admin/dashboard',
		name: 'AdminPanel',
		component: AdminPanelDashboard,
		meta: {
			requiresAuth: true,
			roles: ADMIN_ONLY_ROLES,
			title: 'Админ-панель',
		},
	},
	{
		path: '/admin/users',
		name: 'UserManagement',
		component: UserManagement,
		meta: {
			requiresAuth: true,
			roles: ADMIN_ONLY_ROLES,
			title: 'Управление пользователями',
		},
	},
	{
		path: '/admin/courses/create',
		name: 'AdminCreateCourse',
		component: AdminCreateCourse,
		props: { routeMode: 'create', routeCourseId: null },
		meta: {
			requiresAuth: true,
			roles: ADMIN_ONLY_ROLES,
			title: 'Создание курса',
		},
	},
	{
		path: '/admin/courses/:id/content',
		name: 'AdminCourseContent',
		component: AdminCreateCourse,
		props: route => ({ routeMode: 'content', routeCourseId: route.params.id || null }),
		meta: {
			requiresAuth: true,
			roles: ADMIN_ONLY_ROLES,
			title: 'Управление курсом',
		},
	},
	{
		path: '/admin/courses/:id/edit',
		name: 'AdminCourseEdit',
		component: AdminCreateCourse,
		props: route => ({ routeMode: 'edit', routeCourseId: route.params.id || null }),
		meta: {
			requiresAuth: true,
			roles: ADMIN_ONLY_ROLES,
			title: 'Редактирование курса',
		},
	},
	{
		path: '/admin/courses/:id',
		name: 'AdminCoursePage',
		redirect: to => `/admin/courses/${to.params.id}/content`,
		meta: {
			requiresAuth: true,
			roles: ADMIN_ONLY_ROLES,
		},
	},
	{
		path: '/admin/courses/:id/map',
		name: 'AdminCourseMap',
		component: () => import('@/views/admin/AdminCourseMap.vue'),
		meta: {
			requiresAuth: true,
			roles: ADMIN_ONLY_ROLES,
			title: 'Карта курса',
		},
	},
	{
		path: '/admin/courses',
		name: 'CourseManagement',
		component: CourseManagement,
		meta: {
			requiresAuth: true,
			roles: ADMIN_ONLY_ROLES,
			title: 'Управление курсами',
		},
	},
	{
		path: '/admin/analytics',
		name: 'Analytics',
		component: Analytics,
		meta: {
			requiresAuth: true,
			roles: ADMIN_ONLY_ROLES,
			title: 'Аналитика',
		},
	},
]
